import { Button } from '@braskai/ui-kit';

import { Typography } from '@mui/material';

type ReadyNotificationContentProps = {
  message: string;
  onOpen: () => void;
};

export const ReadyNotificationContent = ({ message, onOpen }: ReadyNotificationContentProps) => (
  <>
    <Typography color="inherit" component="span" variant="body-2-md">
      {message}
    </Typography>{' '}
    <Button data-testid="ready-notification-content-open-project" size="sm" variant="link" noPadding onClick={onOpen}>
      Open project
    </Button>
  </>
);
